import Vue from 'vue'
import { pushToDataLayer } from '@/utils/gtm'
import {
  fireEvent,
  registerEventListener,
  unregisterEventListener
} from '@/events/helpers'
import { identifyUserEvent } from '@/utils/account'
import { datadogRum } from '@datadog/browser-rum'
import isEmpty from 'lodash/isEmpty'

export default ({ app, store }) => {
  Vue.use(plugin, { app, store })
}

const plugin = {
  install: (VueInstance, { app, store }) => {
    app.router.afterEach(() => {
      const otaUserId = store?.state?.auth?.user?.user?._id ?? ''

      setTimeout(() => {
        pushToDataLayer({
          event: 'custom_page_load'
        })

        if (otaUserId) {
          identifyUserEvent({ otaUserId: `${otaUserId}` })

          try {
            const datadogUser = datadogRum.getUser()

            if (isEmpty(datadogUser)) {
              datadogRum.setUser({
                id: `${otaUserId}`,
                country: store?.state?.auth?.user?.user?.country?.name.toLowerCase() ?? ''
              })
            }
          } catch (error) {}
        }
      }, 2000)
    })

    VueInstance.prototype.$fireEvent = fireEvent
    VueInstance.prototype.$registerEventListener = registerEventListener
    VueInstance.prototype.$unregisterEventListener = unregisterEventListener
  }
}
